import { makeActionCreator } from '../../config/store/utils'
import { getOrganization, getOrganizations } from '../../services/organizations'

export const GET_ORGANIZATION = 'GET_ORGANIZATION'
export const GET_ORGANIZATION_ERROR = 'GET_ORGANIZATION_ERROR'
export const GET_ORGANIZATION_SUCCESS = 'GET_ORGANIZATION_SUCCESS'
export const onGetOrganization = makeActionCreator(GET_ORGANIZATION)
export const onGetOrganizationError = makeActionCreator(GET_ORGANIZATION_ERROR, 'payload')
export const onGetOrganizationSuccess = makeActionCreator(GET_ORGANIZATION_SUCCESS, 'payload')
export const onGetOrganizationThunk = payload => async dispatch => {
  dispatch(onGetOrganization())

  try {
    const { data } = await getOrganization({ id: payload.id })

    return dispatch(
      onGetOrganizationSuccess({
        organizations: [{ name: data.payload?.nombre || '', value: data.payload?.id || '' }]
      })
    )
  } catch (error) {
    return dispatch(onGetOrganizationError({ error }))
  }
}

export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS'
export const GET_ORGANIZATIONS_ERROR = 'GET_ORGANIZATIONS_ERROR'
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS'
export const onGetOrganizations = makeActionCreator(GET_ORGANIZATIONS)
export const onGetOrganizationsError = makeActionCreator(GET_ORGANIZATIONS_ERROR, 'payload')
export const onGetOrganizationsSuccess = makeActionCreator(GET_ORGANIZATIONS_SUCCESS, 'payload')
export const onGetOrganizationsThunk = payload => async dispatch => {
  dispatch(onGetOrganizations())

  try {
    const { data } = await getOrganizations({ actionType: GET_ORGANIZATIONS, pattern: payload.pattern })

    return dispatch(
      onGetOrganizationsSuccess({
        organizations:
          data?.payload.organismos.map(item => ({
            name: item.nombre,
            value: item.id
          })) || []
      })
    )
  } catch (error) {
    return dispatch(onGetOrganizationsError({ error }))
  }
}
